import React from 'react';
import { Inspector } from 'react-dev-inspector';
import { LocaleProvider } from '@meitu/xdesign-i18n';
import { useLocaleStore } from './i18n';
import { isDevelopEnv } from './utils/env';

interface RootProps {
    children: React.ReactNode;
}

const Root: React.FC<RootProps> = ({ children }) => {
    const { locale } = useLocaleStore();

    return (
        <LocaleProvider locale={locale}>
            {children}
            {isDevelopEnv() && (
                <Inspector
                    keys={['command', 'shift', 'z']}
                    disableLaunchEditor={true}
                    onClickElement={({ codeInfo }) => {
                        if (!codeInfo?.absolutePath) return;
                        const { absolutePath, lineNumber, columnNumber } = codeInfo;
                        const EDITOR_APP = 'cursor'; // 或者 'vscode'
                        window.open(`${EDITOR_APP}://file/${absolutePath}:${lineNumber}:${columnNumber}`);
                    }}
                />
            )}
        </LocaleProvider>
    );
};

export default Root;
